import type { ElementType, FC, MouseEventHandler } from 'react';
import type { ICON } from '@george-labs.com/george-assets/icons';
import type { ButtonProps } from '@george-labs.com/design-system/types/components/Button/NewButton';

import { DetailPageStripeRightPlainButton } from './DetailPageStripeRightPlainButton';
import { DetailPageStripeRightActionButton } from './DetailPageStripeRightActionButton';

interface DetailPageStripeButtonProps {
    renderPlainButton?: boolean;
    plainButtonProps?: Pick<ButtonProps, 'variant' | 'size' | 'hiddenLabel'>;
    actionSticky?: boolean;
    actionHref?: string;
    actionIcon?: ICON;
    actionDataCy?: string;
    isActionHidden?: boolean;
    onActionClick?: MouseEventHandler<HTMLButtonElement>;
    actionComponent?: ElementType;
    isActionPending?: boolean;
    actionLabel?: string;
}

export const DetailPageRightButton: FC<DetailPageStripeButtonProps> = ({
    renderPlainButton,
    plainButtonProps,
    actionSticky,
    actionHref,
    actionIcon,
    actionDataCy = 'detail-page-action-btn',
    isActionHidden,
    onActionClick,
    actionComponent,
    isActionPending,
    actionLabel,
}) => {
    if (renderPlainButton) {
        return (
            <DetailPageStripeRightPlainButton
                sticky={actionSticky}
                href={actionHref}
                icon={actionIcon}
                data-cy={actionDataCy}
                isHidden={isActionHidden}
                onClick={onActionClick}
                component={actionComponent}
                isLoading={isActionPending}
                {...plainButtonProps}
            >
                {actionLabel}
            </DetailPageStripeRightPlainButton>
        );
    }
    return (
        <DetailPageStripeRightActionButton
            sticky={actionSticky}
            href={actionHref}
            icon={actionIcon}
            data-cy={actionDataCy}
            isHidden={isActionHidden}
            onClick={onActionClick}
            component={actionComponent}
            isLoading={isActionPending}
        >
            {actionLabel}
        </DetailPageStripeRightActionButton>
    );
};
